/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { passwordRegExp } from '../../../../constants/regExps';

export const validationSchema = Yup.object({
  oldPassword: Yup.string().required('empty'),
  newPassword: Yup.string().required('invalid_password').matches(passwordRegExp, 'invalid_password'),
  newPasswordConfirm: Yup.string()
    .required('empty')
    .oneOf([Yup.ref('newPassword')], 'no_match'),
});
